import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { WmButton, WmFile, WmOption, WmSelect, WmToggletip, WmUploader, } from "@watermarkinsights/ripple-react";
import { useEffect, useState, useRef } from "react";
import { closeFlyout, focusButtonComponent, focusUploaderComponentButton, isNullOrEmpty, openFlyout, urlPatternValidation, } from "../../static/js/commons.js";
import translate from "../../i18n/translate";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { applicationSelector, setComponentDetails, setIsEditComponentClicked, updateComponentDetails, } from "./ApplicationSlice";
import { TemplateComponentList } from "./data/TemplateComponentList.js";
import { generateUTCDate, getCategoryByKey, getI18nValueByKey, getIconByType, getValueByKey, } from "../common/commonActions";
import Inputfield from "../../features/common/component/InputField";
import useFileupload from "../../features/common/hooks/useFileUpload";
import ComponentLabelField from "./template-components/ComponentLabelField";
import TemplateComponentOptions from "./template-components/TemplateComponentOptions";
import ComponentTextAreaField from "./template-components/ComponentTextAreaField";
import { SmallTextFieldType } from "./data/SmallTextFieldType.js";
import { format } from "date-fns";
export default function InsertComponent({ setInsertComponent, sortOrder, componentObj, flyoutMode, }) {
    const dispatch = useDispatch();
    const { applicationComponentList, isEditComponentClicked } = useSelector(applicationSelector);
    const titleRef = useRef();
    const [flyoutView, setFlyoutView] = useState(flyoutMode);
    const [templateComponent, setTemplateComponent] = useState();
    const [isFocused, setFocused] = useState(null);
    const [inputTextArea, setInputTextArea] = useState((componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentType) == "TEXT" ? componentObj === null || componentObj === void 0 ? void 0 : componentObj.inputText : "");
    const [smallTextInputLabel, setSmallTextInputLabel] = useState((componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentType) == "SMALL_TEXT_FIELD"
        ? componentObj === null || componentObj === void 0 ? void 0 : componentObj.inputText
        : "");
    const [smallTextTypeValue, setSmallTextTypeValue] = useState((componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentType) == "SMALL_TEXT_FIELD"
        ? componentObj === null || componentObj === void 0 ? void 0 : componentObj.smallTextType
        : "Select Option");
    const [sectionHeaderInputLabel, setSectionHeaderInputLabel] = useState((componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentType) == "SECTION_HEADER"
        ? componentObj === null || componentObj === void 0 ? void 0 : componentObj.inputText
        : "");
    const [linkResourceInputLabel, setLinkResourceInputLabel] = useState((componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentType) == "LINK_RESOURCE"
        ? componentObj === null || componentObj === void 0 ? void 0 : componentObj.inputText
        : "");
    const [largeTextAreaInputLabel, setLargeTextAreaInputLabel] = useState((componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentType) == "LARGE_TEXT_AREA"
        ? componentObj === null || componentObj === void 0 ? void 0 : componentObj.inputText
        : "");
    const [wordLimitInputLable, setWordLimitInputLable] = useState((componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentType) == "LARGE_TEXT_AREA"
        ? componentObj === null || componentObj === void 0 ? void 0 : componentObj.contentLimit
        : 500);
    const [fileUploadInputLabel, setFileUploadInputLabel] = useState((componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentType) == "FILE_UPLOAD"
        ? componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentLabel
        : "");
    const [maxFiles, setMaxFiles] = useState((componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentType) == "FILE_UPLOAD"
        ? componentObj === null || componentObj === void 0 ? void 0 : componentObj.contentLimit
        : 5);
    const [linkDisplayTextLabel, setLinkDisplayTextLabel] = useState((componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentType) == "LINK_RESOURCE"
        ? componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentLabel
        : "");
    const [attachmentDisplayTextLabel, setAttachmentDisplayTextLabel] = useState((componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentType) == "ATTACHMENT"
        ? componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentLabel
        : "");
    const [linkStudentInputLabel, setLinkStudentInputLabel] = useState((componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentType) == "LINK_INPUT" ? componentObj === null || componentObj === void 0 ? void 0 : componentObj.inputText : "");
    const [dateSelectorInputLabel, setDateSelectorInputLabel] = useState((componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentType) == "DATE_SELECTOR"
        ? componentObj === null || componentObj === void 0 ? void 0 : componentObj.inputText
        : "");
    const [dropDownDisplayTextLabel, setDropDownDisplayTextLabel] = useState((componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentType) == "DROPDOWN"
        ? componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentLabel
        : "");
    const [multiSelectDisplayTextLabel, setMultiSelectDisplayTextLabel] = useState((componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentType) == "MULTISELECT_CHECKBOXES"
        ? componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentLabel
        : "");
    const [radioButtonDisplayTextLabel, setRadioButtonDisplayTextLabel] = useState((componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentType) == "RADIO_BUTTON"
        ? componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentLabel
        : "");
    const [ackCheckboxInputText, setAckCheckboxInputText] = useState((componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentType) == "ACKNOWLEDGEMENT_CHECKBOX"
        ? componentObj === null || componentObj === void 0 ? void 0 : componentObj.inputText
        : "");
    const [ackCheckboxDisplayTextLabel, setAckCheckboxDisplayTextLabel] = useState((componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentType) == "ACKNOWLEDGEMENT_CHECKBOX"
        ? componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentLabel
        : "");
    const [isMandatory, setIsMandatory] = useState((componentObj === null || componentObj === void 0 ? void 0 : componentObj.isMandatory) ? true : false);
    const maxWordCountLargeTextArea = 500;
    const maxFilesCountFileUpload = 5;
    const [invalidLinkError, setInvalidLinkError] = useState(false);
    const [textareaError, setTextareaError] = useState(false);
    const [inputFieldError, setInputFieldError] = useState(false);
    const [largeInputAreaLabelError, setLargeInputAreaLabelError] = useState(false);
    const [wordLimitError, setWordLimitError] = useState(false);
    const [maxFilesError, setMaxFilesError] = useState(false);
    const [noAttachmentError, setNoAttachmentError] = useState(false);
    const [dropDownLabelError, setDropDownLabelError] = useState(false);
    const [multiSelectLabelError, setMultiSelectLabelError] = useState(false);
    const [radiobuttonLabelError, setRadiobuttonLabelError] = useState(false);
    const [dropDownError, setDropDownError] = useState(false);
    const [checkboxError, setCheckboxError] = useState(false);
    const [ackTextError, setAckTextError] = useState(false);
    const [editedComponent, setEditedComponent] = useState({
        type: componentObj != undefined ? componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentType : "",
        uuid: componentObj != undefined ? componentObj === null || componentObj === void 0 ? void 0 : componentObj.uuid : "",
        category: componentObj != undefined ? componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentCategory : "",
        sortOrder: componentObj != undefined ? componentObj === null || componentObj === void 0 ? void 0 : componentObj.sortOrder : 0,
        createdBy: "",
        createdAt: "",
        updatedBy: "",
        updatedAt: "",
    });
    let uploaderRef = useRef();
    const [attachedFiles, deletedFiles, uploadInProgress, , onWmUploaderFilesSelected, onWmUploaderDownloadFile, onWmUploaderDeleteFile, setAttachedFiles, , currentFiles,] = useFileupload({
        app: "APPLICATIONS",
        type: "APPLICATION_TEMPLATE",
        initialAttachments: componentObj === null || componentObj === void 0 ? void 0 : componentObj.files,
        componentRef: uploaderRef,
        initialDeletedFiles: componentObj === null || componentObj === void 0 ? void 0 : componentObj.deletedFiles,
    });
    const [uploaderComponentFiles, setUploaderComponentFiles] = useState([]);
    const [smallTextError, setSmallTextError] = useState(false);
    const [extraFileError, setExtraFileError] = useState(false);
    const extraFileErrorMessage = useIntl().formatMessage({
        id: "app.programApplications.student.application.fileupload.extra.file.error.message",
    });
    const defaultOptionsList = [
        {
            uuid: "",
            templateComponentUuid: "",
            text: "",
            sortOrder: 0,
            valid: false,
        },
        {
            uuid: "",
            templateComponentUuid: "",
            text: "",
            sortOrder: 1,
            valid: false,
        },
    ];
    const [optionList, setOptionList] = useState((componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentOptionList)
        ? componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentOptionList
        : defaultOptionsList);
    const textTypeLabel = useIntl().formatMessage({
        id: "app.programApplications.small.text.field.component.content.type.label",
    });
    const typeErrorMessage = useIntl().formatMessage({
        id: "app.programApplications.small.text.field.component.type.info",
    });
    useEffect(() => {
        const uploaderFiles = attachedFiles.map((file) => {
            const progressIndicator = uploadInProgress && currentFiles.indexOf(file.uuid) > -1
                ? { progress: 0 }
                : { progress: 100 };
            const uploaderFile = Object.assign({ id: file.uuid, name: file.file_name.substr(0, file.file_name.lastIndexOf(".")), type: file.file_name.substr(file.file_name.lastIndexOf(".") + 1), lastUpdated: file.inserted_at, fileActions: uploadInProgress ? "download" : "download delete" }, progressIndicator);
            return uploaderFile;
        });
        setUploaderComponentFiles(uploaderFiles);
    }, [attachedFiles, uploadInProgress]);
    useEffect(() => {
        if (!isEditComponentClicked) {
            setTimeout(() => openFlyout("insert-component-flyout", "insert-component", "section_header-btn"), 200);
        }
        else {
            setTimeout(() => openFlyout("insert-component-flyout", "insert-component", getFocusId()), 200);
        }
    }, []);
    useEffect(() => {
        if (flyoutMode == "componentSettings") {
            openComponentView(flyoutMode, editedComponent);
        }
    }, []);
    const getFocusId = () => {
        switch (editedComponent.type) {
            case "TEXT":
                return document.getElementById(editedComponent.type.toLowerCase());
            default:
                return document.getElementById("input-" + editedComponent.type.toLowerCase());
        }
    };
    const closeFlyoutHandler = (event) => {
        event.preventDefault();
        setInsertComponent(false);
        closeFlyout();
        focusButtonComponent("insert-component");
    };
    const resourceContentMoreInfoLabel = useIntl().formatMessage({
        id: "app.programApplications.resource.content.moreInfoLabel",
    });
    const studentInputMoreInfoLabel = useIntl().formatMessage({
        id: "app.programApplications.student.input.moreInfoLabel",
    });
    const resourceContentToggleTip = useIntl().formatMessage({
        id: "app.programApplications.resource.content.tooltip",
    });
    const studentInputToggleTip = useIntl().formatMessage({
        id: "app.programApplications.student.input.tooltip",
    });
    const flyoutCloseToolTip = useIntl().formatMessage({
        id: "app.cohort.secondaryButtonText",
    });
    const textErrorMessage = useIntl().formatMessage({
        id: "app.programApplications.insertComponent.textArea.error.message",
    });
    const inputFieldErrorMessage = useIntl().formatMessage({
        id: "app.programApplications.insertComponent.inputField.error.message",
    });
    const sectionHeaderErrorMessage = useIntl().formatMessage({
        id: "app.programApplications.insertComponent.section.header.error.message",
    });
    const urlRequiredErrorMessage = useIntl().formatMessage({
        id: "app.programApplications.insertComponent.resource.link.error.message.blank",
    });
    const urlInvalidErrorMessage = useIntl().formatMessage({
        id: "app.programApplications.insertComponent.resource.link.error.message.invalid",
    });
    const wordLimitErrorMessage = useIntl().formatMessage({
        id: "app.programApplications.component.largeTextArea.wordLimit.error.message",
    });
    const maxFilesLabel = useIntl().formatMessage({
        id: "app.programApplications.component.file.upload.max.file.label",
    });
    const maxFilesErrorMessage = useIntl().formatMessage({
        id: "app.programApplications.component.file.upload.required.msg",
    });
    const attachButtonText = useIntl().formatMessage({
        id: "app.programApplications.component.attachment.attach.files.label",
    });
    const attachEmptyStateText = useIntl().formatMessage({
        id: "app.requirement.emptyStateText",
    });
    const attachFilesLabel = useIntl().formatMessage({
        id: "app.programApplications.component.attachment.attach.files.label",
    });
    const noAttachmentErrorMsg = useIntl().formatMessage({
        id: "app.programApplications.insertComponent.attach.file.error.message",
    });
    const ackTextLabel = useIntl().formatMessage({
        id: "app.programApplications.component.acknowledgement.checkbox.text.area.label",
    });
    const ackInputTextError = useIntl().formatMessage({
        id: "app.programApplications.component.acknowledgement.checkbox.required.msg",
    });
    const ackCheckboxHelpText = useIntl().formatMessage({
        id: "app.programApplications.component.acknowledgement.checkbox.info.text",
    });
    const openComponentView = (viewType, component) => {
        setFlyoutView(viewType);
        setTemplateComponent(component);
        switch (component.type) {
            case "TEXT":
                setTimeout(() => { var _a; return (_a = document.getElementById(component.type.toLowerCase())) === null || _a === void 0 ? void 0 : _a.focus(); }, 10);
                return;
            default:
                setTimeout(() => {
                    var _a;
                    return (_a = document
                        .getElementById("input-" + component.type.toLowerCase())) === null || _a === void 0 ? void 0 : _a.focus();
                }, 10);
                return;
        }
    };
    const goBackHandler = () => {
        setTextareaError(false);
        setIsMandatory(false);
        setInputFieldError(false);
        setInvalidLinkError(false);
        setNoAttachmentError(false);
        setLargeInputAreaLabelError(false);
        setWordLimitError(false);
        setMaxFilesError(false);
        setAckTextError(false);
        setDropDownLabelError(false);
        setMultiSelectLabelError(false);
        setRadiobuttonLabelError(false);
        setOptionList(defaultOptionsList);
        setSmallTextInputLabel("");
        setSmallTextTypeValue("Select Option");
        setSmallTextError(false);
        setSectionHeaderInputLabel("");
        setLinkStudentInputLabel("");
        setDateSelectorInputLabel("");
        setLargeTextAreaInputLabel("");
        setWordLimitInputLable(500);
        setInputTextArea("");
        setFileUploadInputLabel("");
        setMaxFiles(5);
        setLinkResourceInputLabel("");
        setLinkDisplayTextLabel("");
        setAttachmentDisplayTextLabel("");
        setUploaderComponentFiles([]);
        setDropDownDisplayTextLabel("");
        setMultiSelectDisplayTextLabel("");
        setRadioButtonDisplayTextLabel("");
        setAckCheckboxDisplayTextLabel("");
        setAckCheckboxInputText("");
        setAttachedFiles([]);
        setFlyoutView("chooseComponent");
        setTimeout(() => {
            var _a;
            (_a = document
                .getElementById((templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type.toLowerCase()) + "-btn")) === null || _a === void 0 ? void 0 : _a.focus();
        }, 10);
    };
    const updateDesciptionHandler = (event) => {
        event.preventDefault();
        setInputTextArea(event.target.value);
        if (event.target.value.trim() != "") {
            setTextareaError(false);
        }
    };
    const updateAckCheckboxTextHandler = (event) => {
        event.preventDefault();
        setAckCheckboxInputText(event.target.value);
        if (event.target.value.trim() != "") {
            setAckTextError(false);
        }
    };
    const updateInputHandler = (event, type) => {
        event.preventDefault();
        type === "SMALL_TEXT_FIELD"
            ? setSmallTextInputLabel(event.target.value)
            : type === "LINK_INPUT"
                ? setLinkStudentInputLabel(event.target.value)
                : type === "DATE_SELECTOR"
                    ? setDateSelectorInputLabel(event.target.value)
                    : setSectionHeaderInputLabel(event.target.value);
        if (event.target.value.trim() != "") {
            setInputFieldError(false);
        }
    };
    const updateResourceLinkHandler = (event) => {
        event.preventDefault();
        setLinkResourceInputLabel(event.target.value);
        if (event.target.value.trim() != "") {
            setInputFieldError(false);
        }
    };
    const validateURLHandler = (event) => {
        const { value } = event.target;
        if (value) {
            setInvalidLinkError(!urlPatternValidation(value));
        }
    };
    const updateLargeTextAreaInputHandler = (event) => {
        event.preventDefault();
        setLargeTextAreaInputLabel(event.target.value);
        if (event.target.value.trim() != "") {
            setLargeInputAreaLabelError(false);
        }
    };
    const updateFileUploadInputHandler = (event) => {
        event.preventDefault();
        setFileUploadInputLabel(event.target.value);
        if (event.target.value.trim() != "") {
            setInputFieldError(false);
        }
    };
    const updateDropDownInputHandler = (event) => {
        event.preventDefault();
        setDropDownDisplayTextLabel(event.target.value);
        if (event.target.value.trim() != "") {
            setDropDownLabelError(false);
        }
    };
    const updateMultiSelectInputHandler = (event) => {
        event.preventDefault();
        setMultiSelectDisplayTextLabel(event.target.value);
        if (event.target.value.trim() != "") {
            setMultiSelectLabelError(false);
        }
    };
    const updateRadioButtonSelectInputHandler = (event) => {
        event.preventDefault();
        setRadioButtonDisplayTextLabel(event.target.value);
        if (event.target.value.trim() != "") {
            setRadiobuttonLabelError(false);
        }
    };
    const updateMaxFilesCountHandler = (event) => {
        event.preventDefault();
        if (parseInt(event.target.value) > maxFilesCountFileUpload) {
            setMaxFiles(maxFilesCountFileUpload);
            setMaxFilesError(false);
            return;
        }
        else if (event.target.value.trim() != "") {
            setMaxFilesError(false);
        }
        setMaxFiles(event.target.value);
    };
    const updateWordLimitInputHandler = (event) => {
        event.preventDefault();
        if (parseInt(event.target.value) > maxWordCountLargeTextArea) {
            setWordLimitInputLable(maxWordCountLargeTextArea);
            return;
        }
        else if (event.target.value.trim() != "") {
            setWordLimitError(false);
        }
        setWordLimitInputLable(event.target.value);
    };
    const saveApplicationComponentHandler = () => {
        let componentType = templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type;
        let inputText = "";
        let componentLabel = "";
        let contentLimit = "";
        let type = componentType == "SMALL_TEXT_FIELD" ? smallTextTypeValue : "";
        switch (componentType) {
            case "TEXT":
                if (inputTextArea.trim() == "") {
                    setTextareaError(true);
                    setTimeout(() => {
                        var _a;
                        (_a = document.getElementById("text")) === null || _a === void 0 ? void 0 : _a.focus();
                    }, 10);
                    return;
                }
                inputText = inputTextArea;
                break;
            case "SMALL_TEXT_FIELD":
                if (smallTextInputLabel.trim() === "" ||
                    isNullOrEmpty(type) ||
                    type === "Select Option") {
                    if (smallTextInputLabel.trim() === "") {
                        setInputFieldError(true);
                        setTimeout(() => {
                            var _a;
                            (_a = document.getElementById("input-small_text_field")) === null || _a === void 0 ? void 0 : _a.focus();
                        }, 10);
                    }
                    if (isNullOrEmpty(type) || type === "Select Option") {
                        setSmallTextError(true);
                        if (smallTextInputLabel.trim() !== "") {
                            setTimeout(() => {
                                var _a;
                                (_a = document.getElementById("small-text-field_type")) === null || _a === void 0 ? void 0 : _a.focus();
                            }, 10);
                        }
                    }
                    return;
                }
                inputText = smallTextInputLabel;
                break;
            case "SECTION_HEADER":
                if (sectionHeaderInputLabel.trim() == "") {
                    setInputFieldError(true);
                    setTimeout(() => {
                        var _a;
                        (_a = document.getElementById("input-section_header")) === null || _a === void 0 ? void 0 : _a.focus();
                    }, 10);
                    return;
                }
                inputText = sectionHeaderInputLabel;
                break;
            case "LINK_RESOURCE":
                if (linkResourceInputLabel.trim() == "" ||
                    !urlPatternValidation(linkResourceInputLabel)) {
                    setInputFieldError(true);
                    setTimeout(() => {
                        var _a;
                        (_a = document.getElementById("input-link_resource")) === null || _a === void 0 ? void 0 : _a.focus();
                    }, 10);
                    return;
                }
                inputText = linkResourceInputLabel;
                componentLabel = linkDisplayTextLabel;
                break;
            case "LARGE_TEXT_AREA":
                if (isNullOrEmpty(wordLimitInputLable) ||
                    wordLimitInputLable > maxWordCountLargeTextArea ||
                    isNullOrEmpty(largeTextAreaInputLabel.trim())) {
                    if (isNullOrEmpty(largeTextAreaInputLabel.trim())) {
                        setLargeInputAreaLabelError(true);
                        if (isNullOrEmpty(largeTextAreaInputLabel.trim()) ||
                            (isNullOrEmpty(largeTextAreaInputLabel.trim()) &&
                                (isNullOrEmpty(wordLimitInputLable) ||
                                    wordLimitInputLable > maxWordCountLargeTextArea))) {
                            setTimeout(() => {
                                var _a;
                                (_a = document.getElementById("input-large_text_area")) === null || _a === void 0 ? void 0 : _a.focus();
                            }, 100);
                        }
                    }
                    if (isNullOrEmpty(wordLimitInputLable) ||
                        wordLimitInputLable > maxWordCountLargeTextArea) {
                        setWordLimitError(true);
                        if (!isNullOrEmpty(largeTextAreaInputLabel.trim()) &&
                            (isNullOrEmpty(wordLimitInputLable) ||
                                wordLimitInputLable > maxWordCountLargeTextArea)) {
                            setTimeout(() => {
                                var _a;
                                (_a = document.getElementById("input-large_text_area-limit")) === null || _a === void 0 ? void 0 : _a.focus();
                            }, 100);
                        }
                    }
                    return;
                }
                inputText = largeTextAreaInputLabel;
                contentLimit = wordLimitInputLable.toString();
                break;
            case "FILE_UPLOAD":
                if (isNullOrEmpty(maxFiles) ||
                    maxFiles > maxFilesCountFileUpload ||
                    isNullOrEmpty(fileUploadInputLabel.trim())) {
                    if (isNullOrEmpty(fileUploadInputLabel.trim())) {
                        setInputFieldError(true);
                        if (isNullOrEmpty(fileUploadInputLabel.trim()) ||
                            (isNullOrEmpty(fileUploadInputLabel.trim()) &&
                                (isNullOrEmpty(maxFiles) || maxFiles > maxFilesCountFileUpload))) {
                            setTimeout(() => {
                                var _a;
                                (_a = document.getElementById("input-file_upload")) === null || _a === void 0 ? void 0 : _a.focus();
                            }, 100);
                        }
                    }
                    if (isNullOrEmpty(maxFiles) || maxFiles > maxFilesCountFileUpload) {
                        setMaxFilesError(true);
                        if (!isNullOrEmpty(fileUploadInputLabel.trim()) &&
                            (isNullOrEmpty(maxFiles) || maxFiles > maxFilesCountFileUpload)) {
                            setTimeout(() => {
                                var _a;
                                (_a = document.getElementById("input-file_upload-max-files")) === null || _a === void 0 ? void 0 : _a.focus();
                            }, 100);
                        }
                    }
                    return;
                }
                componentLabel = fileUploadInputLabel;
                contentLimit = maxFiles.toString();
                break;
            case "ATTACHMENT":
                if (!attachedFiles.length) {
                    setNoAttachmentError(true);
                    setTimeout(() => {
                        focusUploaderComponentButton("attach-file-component");
                    }, 10);
                    return;
                }
                componentLabel = attachmentDisplayTextLabel;
                break;
            case "LINK_INPUT":
                if (linkStudentInputLabel.trim() == "") {
                    setInputFieldError(true);
                    setTimeout(() => {
                        var _a;
                        (_a = document.getElementById("input-link_input")) === null || _a === void 0 ? void 0 : _a.focus();
                    }, 10);
                    return;
                }
                inputText = linkStudentInputLabel;
                break;
            case "DROPDOWN":
                let error = false;
                const options = optionList.map((elem) => {
                    if (isNullOrEmpty(elem.text.trim())) {
                        error = true;
                        return Object.assign(Object.assign({}, elem), { valid: true });
                    }
                    else {
                        return Object.assign(Object.assign({}, elem), { valid: false });
                    }
                });
                setOptionList(options);
                if (isNullOrEmpty(dropDownDisplayTextLabel.trim()) || error) {
                    if (isNullOrEmpty(dropDownDisplayTextLabel.trim())) {
                        setDropDownLabelError(true);
                        setTimeout(() => {
                            var _a;
                            (_a = document.getElementById("input-dropdown")) === null || _a === void 0 ? void 0 : _a.focus();
                        }, 10);
                    }
                    if (error) {
                        setDropDownError(true);
                        if (!isNullOrEmpty(dropDownDisplayTextLabel.trim())) {
                            let tempIndex = options.findIndex((item) => item.valid === true);
                            setTimeout(() => {
                                var _a;
                                (_a = document
                                    .getElementById("input-option-" + (tempIndex + 1))) === null || _a === void 0 ? void 0 : _a.focus();
                            }, 10);
                        }
                    }
                    return;
                }
                componentLabel = dropDownDisplayTextLabel;
                break;
            case "MULTISELECT_CHECKBOXES":
                let err = false;
                const checkboxOptions = optionList.map((elem) => {
                    if (isNullOrEmpty(elem.text.trim())) {
                        err = true;
                        return Object.assign(Object.assign({}, elem), { valid: true });
                    }
                    else {
                        return Object.assign(Object.assign({}, elem), { valid: false });
                    }
                });
                setOptionList(checkboxOptions);
                if (isNullOrEmpty(multiSelectDisplayTextLabel.trim()) || err) {
                    if (isNullOrEmpty(multiSelectDisplayTextLabel.trim())) {
                        setMultiSelectLabelError(true);
                        setTimeout(() => {
                            var _a;
                            (_a = document.getElementById("input-multiselect_checkboxes")) === null || _a === void 0 ? void 0 : _a.focus();
                        }, 10);
                    }
                    if (err) {
                        setCheckboxError(true);
                        if (!isNullOrEmpty(multiSelectDisplayTextLabel.trim())) {
                            let tempIndex = checkboxOptions.findIndex((item) => item.valid === true);
                            setTimeout(() => {
                                var _a;
                                (_a = document
                                    .getElementById("input-option-" + (tempIndex + 1))) === null || _a === void 0 ? void 0 : _a.focus();
                            }, 10);
                        }
                    }
                    return;
                }
                componentLabel = multiSelectDisplayTextLabel;
                break;
            case "ACKNOWLEDGEMENT_CHECKBOX":
                if (ackCheckboxInputText.trim() == "") {
                    setAckTextError(true);
                    setTimeout(() => {
                        var _a;
                        (_a = document
                            .getElementById("textarea-acknowledgement_checkbox")) === null || _a === void 0 ? void 0 : _a.focus();
                    }, 10);
                    return;
                }
                inputText = ackCheckboxInputText;
                componentLabel = ackCheckboxDisplayTextLabel;
                break;
            case "DATE_SELECTOR":
                if (dateSelectorInputLabel.trim() == "") {
                    setInputFieldError(true);
                    setTimeout(() => {
                        var _a;
                        (_a = document.getElementById("input-date_selector")) === null || _a === void 0 ? void 0 : _a.focus();
                    }, 10);
                    return;
                }
                inputText = dateSelectorInputLabel;
                break;
            case "RADIO_BUTTON":
                let radioButtonError = false;
                const radionButtionOptions = optionList.map((elem) => {
                    if (isNullOrEmpty(elem.text.trim())) {
                        radioButtonError = true;
                        return Object.assign(Object.assign({}, elem), { valid: true });
                    }
                    else {
                        return Object.assign(Object.assign({}, elem), { valid: false });
                    }
                });
                setOptionList(radionButtionOptions);
                if (isNullOrEmpty(radioButtonDisplayTextLabel.trim()) ||
                    radioButtonError) {
                    if (isNullOrEmpty(radioButtonDisplayTextLabel.trim())) {
                        setRadiobuttonLabelError(true);
                        setTimeout(() => {
                            var _a;
                            (_a = document.getElementById("input-radio_button")) === null || _a === void 0 ? void 0 : _a.focus();
                        }, 10);
                    }
                    if (radioButtonError) {
                        setCheckboxError(true);
                        if (!isNullOrEmpty(radioButtonDisplayTextLabel.trim())) {
                            let tempIndex = radionButtionOptions.findIndex((item) => item.valid === true);
                            setTimeout(() => {
                                var _a;
                                (_a = document
                                    .getElementById("input-option-" + (tempIndex + 1))) === null || _a === void 0 ? void 0 : _a.focus();
                            }, 10);
                        }
                    }
                    return;
                }
                componentLabel = radioButtonDisplayTextLabel;
                break;
            default:
                return;
        }
        setInsertComponent(false);
        closeFlyout();
        let componentCategory = componentObj === null || componentObj === void 0 ? void 0 : componentObj.componentType;
        if (!(editedComponent.type == null || editedComponent.type == "")) {
            dispatch(updateComponentDetails({
                uuid: editedComponent.uuid,
                componentType,
                inputText,
                sortOrder,
                componentCategory,
                componentLabel,
                contentLimit,
                attachedFiles,
                deletedFiles,
                files: attachedFiles,
                componentOptionList: optionList,
                isMandatory: isMandatory,
                smallTextType: type,
            }));
            setInputTextArea("");
            setSmallTextInputLabel("");
            setSmallTextTypeValue("Select Option");
            setSmallTextError(false);
            setSectionHeaderInputLabel("");
            setLinkResourceInputLabel("");
            setLinkDisplayTextLabel("");
            setLargeTextAreaInputLabel("");
            setAttachmentDisplayTextLabel("");
            setFileUploadInputLabel("");
            setLinkStudentInputLabel("");
            setAckCheckboxInputText("");
            setAckCheckboxDisplayTextLabel("");
            setDateSelectorInputLabel("");
            setIsMandatory(false);
        }
        else {
            dispatch(setComponentDetails({
                componentType,
                inputText,
                sortOrder,
                componentCategory,
                componentLabel,
                contentLimit,
                attachedFiles,
                deletedFiles,
                files: attachedFiles,
                componentOptionList: optionList,
                isMandatory: isMandatory,
                smallTextType: type,
            }));
        }
        dispatch(setIsEditComponentClicked(false));
    };
    const getComponentInfoByKey = (type) => {
        switch (type) {
            case "TEXT":
                return translate("app.programApplications.component.text.info.text");
            case "SMALL_TEXT_FIELD":
                return translate("app.programApplications.component.small.text.field.info.text");
            case "SECTION_HEADER":
                return translate("app.programApplications.component.section.header.info.text");
            case "LINK_RESOURCE":
                return translate("app.programApplications.component.resource.link.info.text");
            case "LARGE_TEXT_AREA":
                return translate("app.programApplications.component.large.text.area.info.text");
            case "ATTACHMENT":
                return translate("app.programApplications.component.attachment.info.text");
            case "LINK_INPUT":
                return translate("app.programApplications.component.link.student.input.info.text");
            case "DROPDOWN":
                return translate("app.programApplications.component.dropdown.label.info");
            case "FILE_UPLOAD":
                return translate("app.programApplications.component.file.upload.label.info");
            case "MULTISELECT_CHECKBOXES":
                return translate("app.programApplications.component.multiselect.checkboxes.label.info");
            case "ACKNOWLEDGEMENT_CHECKBOX":
                return translate("app.programApplications.component.acknowledgement.checkbox.label.info");
            case "DATE_SELECTOR":
                return translate("app.programApplications.component.date.selector.info");
            case "RADIO_BUTTON":
                return translate("app.programApplications.component.radio.button.info");
            default:
                return "";
        }
    };
    const renderFlyoutHeader = () => {
        if (flyoutView === "chooseComponent") {
            return (_jsx("section", Object.assign({ className: "immersive-header header chooseComponent-header" }, { children: _jsxs("div", Object.assign({ className: "page-header flex-row -justified -verticallycentered" }, { children: [_jsx("h2", Object.assign({ className: "flyout-header-title" }, { children: translate("app.programApplications.choose.component.title") })), _jsx(WmButton, { buttonType: "navigational", icon: "close", tooltip: flyoutCloseToolTip, tooltipPosition: "bottom", id: "flyout-close", class: "hydrated", onClick: (event) => closeFlyoutHandler(event), disabled: uploadInProgress, placeholder: undefined })] })) })));
        }
        else if (!isEditComponentClicked && flyoutView === "componentSettings") {
            return (_jsx("section", Object.assign({ className: "immersive-header header componentSettings-header" }, { children: _jsxs("div", Object.assign({ className: "page-header flex-row -justified -verticallycentered" }, { children: [_jsxs("div", { children: [_jsx("div", Object.assign({ className: "go-back-link program-header flex-row -justified -verticallycentered" }, { children: _jsxs("div", Object.assign({ className: "bread-crumbs" }, { children: [_jsx(WmButton, Object.assign({ "button-type": "textonly", id: "go-back", className: "link", onClick: () => goBackHandler(), placeholder: undefined }, { children: _jsx("span", { children: translate("app.programApplications.choose.component.title") }) })), _jsx("span", { children: translate("app.programApplications.component.settings.title") })] })) })), _jsx("h2", Object.assign({ className: "flyout-header-title" }, { children: translate("app.programApplications.component.settings.title") })), _jsxs("div", Object.assign({ className: "required-fields" }, { children: [translate("app.cohort.requiredText.prefix"), _jsx("span", Object.assign({ className: "reqd" }, { children: "*" })), translate("app.cohort.requiredText.suffix")] }))] }), _jsx(WmButton, { buttonType: "navigational", icon: "close", tooltip: flyoutCloseToolTip, tooltipPosition: "bottom", id: "flyout-close", class: "hydrated", onClick: (event) => closeFlyoutHandler(event), placeholder: undefined })] })) })));
        }
        else if (isEditComponentClicked) {
            return (_jsxs("section", Object.assign({ className: "immersive-header header editComponent-header" }, { children: [_jsxs("div", Object.assign({ className: "page-header flex-row -justified -verticallycentered" }, { children: [_jsx("h2", Object.assign({ className: "flyout-header-title" }, { children: translate("app.programApplications.component.edit.title") })), _jsx(WmButton, { buttonType: "navigational", icon: "close", tooltip: flyoutCloseToolTip, tooltipPosition: "bottom", id: "flyout-close", class: "hydrated", onClick: (event) => closeFlyoutHandler(event), placeholder: undefined })] })), _jsxs("div", Object.assign({ className: "required-fields" }, { children: [translate("app.cohort.requiredText.prefix"), _jsx("span", Object.assign({ className: "reqd" }, { children: "*" })), translate("app.cohort.requiredText.suffix")] }))] })));
        }
        else {
            return;
        }
    };
    const renderMainContent = () => {
        if (flyoutView === "chooseComponent") {
            return (_jsxs("section", Object.assign({ className: "main-content-body" }, { children: [_jsxs("div", Object.assign({ className: "resource-content-area" }, { children: [_jsxs("div", Object.assign({ className: "flex-row section-label" }, { children: [_jsx("h3", Object.assign({ className: "resource-content-title" }, { children: translate("app.programApplications.resource.content.title") })), _jsx(WmToggletip, { id: "resource-content-toggleTip", className: "toggletip", label: resourceContentMoreInfoLabel, tooltip: resourceContentToggleTip, tooltipPosition: "bottom-right", placeholder: undefined })] })), _jsx("div", Object.assign({ className: "resource-content-list", "aria-label": "Resource Content", role: "list" }, { children: applicationComponentList.map((component) => {
                                    if (getValueByKey(component.type, TemplateComponentList) === "") {
                                        return "";
                                    }
                                    if (component.category === "RESOURCE_CONTENT") {
                                        return (_jsx("div", Object.assign({ id: component.type.toLowerCase(), role: "listitem" }, { children: _jsx("button", Object.assign({ id: component.type.toLowerCase() + "-btn", className: "item", onClick: () => {
                                                    openComponentView("componentSettings", component);
                                                }, "aria-label": getValueByKey(component.type, TemplateComponentList) }, { children: _jsxs("div", Object.assign({ className: "item-container flex-row" }, { children: [_jsx("div", Object.assign({ className: "item-icon" }, { children: _jsx("span", { className: getIconByType(component.type) }) })), _jsx("div", Object.assign({ className: "item-name" }, { children: _jsx("span", { children: getI18nValueByKey(component.type, TemplateComponentList) }) }))] })) })) }), component.uuid));
                                    }
                                }) }))] })), _jsxs("div", Object.assign({ className: "student-input-area" }, { children: [_jsxs("div", Object.assign({ className: "flex-row section-label" }, { children: [_jsx("h3", Object.assign({ className: "student-input-title" }, { children: translate("app.programApplications.student.input.title") })), _jsx(WmToggletip, { id: "student-input-toggleTip", className: "toggletip", label: studentInputMoreInfoLabel, tooltip: studentInputToggleTip, tooltipPosition: "bottom-right", placeholder: undefined })] })), _jsx("div", Object.assign({ className: "student-input-list", "aria-label": "Student Input", role: "list" }, { children: applicationComponentList.map((component) => {
                                    if (component.category === "STUDENT_INPUT" &&
                                        component.type != "DEFAULT_COMPONENT") {
                                        return (_jsx("div", Object.assign({ id: component.type.toLowerCase(), role: "listitem" }, { children: _jsx("button", Object.assign({ id: component.type.toLowerCase() + "-btn", className: "item", onClick: () => {
                                                    openComponentView("componentSettings", component);
                                                }, "aria-label": getValueByKey(component.type, TemplateComponentList) }, { children: _jsxs("div", Object.assign({ className: "item-container flex-row" }, { children: [_jsx("div", Object.assign({ className: "item-icon" }, { children: _jsx("span", { className: getIconByType(component.type) }) })), _jsx("div", Object.assign({ className: "item-name" }, { children: _jsx("span", { children: getI18nValueByKey(component.type, TemplateComponentList) }) }))] })) })) }), component.uuid));
                                    }
                                }) }))] }))] })));
        }
        else if (flyoutView === "componentSettings") {
            return (_jsxs("section", Object.assign({ className: "main-content-body immersive-container -height" }, { children: [_jsxs("div", Object.assign({ className: "component-info" }, { children: [_jsx("h3", Object.assign({ className: "component-category" }, { children: getCategoryByKey(templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type, TemplateComponentList) === "STUDENT_INPUT"
                                    ? translate("app.programApplications.student.input.title")
                                    : translate("app.programApplications.resource.content.title") })), _jsx("h4", Object.assign({ className: "component-name" }, { children: getValueByKey(templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type, TemplateComponentList) })), _jsx("p", Object.assign({ className: "component-info-text" }, { children: getComponentInfoByKey(templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type) }))] })), (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type) === "SMALL_TEXT_FIELD" ||
                        (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type) === "SECTION_HEADER" ||
                        (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type) === "LINK_INPUT" ||
                        (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type) === "DATE_SELECTOR" ? (_jsxs(_Fragment, { children: [_jsx(ComponentLabelField, { fieldId: templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type.toLowerCase(), titleError: inputFieldError, isMandatory: isMandatory, setIsMandatory: setIsMandatory, fieldValue: (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type) === "SMALL_TEXT_FIELD"
                                    ? smallTextInputLabel
                                    : (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type) === "SECTION_HEADER"
                                        ? sectionHeaderInputLabel
                                        : (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type) === "DATE_SELECTOR"
                                            ? dateSelectorInputLabel
                                            : linkStudentInputLabel, titleHandler: () => updateInputHandler(event, templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type), errorMessage: (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type) === "SECTION_HEADER"
                                    ? sectionHeaderErrorMessage
                                    : inputFieldErrorMessage }), (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type) === "SMALL_TEXT_FIELD" && (_jsxs("div", Object.assign({ className: "small-text-type-select" }, { children: [_jsxs(WmSelect, Object.assign({ label: textTypeLabel, requiredField: true, labelPosition: "top", id: "small-text-field_type", errorMessage: smallTextError ? typeErrorMessage : "", placeholder: undefined }, { children: [_jsx(WmOption, Object.assign({ "aria-label": "Select Option", selected: smallTextTypeValue === "Select Option", onWmOptionSelected: (event) => {
                                                    event.preventDefault();
                                                    setSmallTextTypeValue("Select Option");
                                                }, placeholder: undefined }, { children: translate("app.requirement.file_type_select_option") }), "option-select-type"), SmallTextFieldType.map((textType) => textType.key).map((type) => {
                                                return (_jsx(WmOption, Object.assign({ "aria-label": getValueByKey(type, SmallTextFieldType), selected: smallTextTypeValue === type, onWmOptionSelected: (event) => {
                                                        event.preventDefault();
                                                        setSmallTextError(false);
                                                        setSmallTextTypeValue(type);
                                                    }, placeholder: undefined }, { children: getI18nValueByKey(type, SmallTextFieldType) }), "option-" + type));
                                            })] }), "select" + templateComponent.uuid), !smallTextError && (_jsx("div", Object.assign({ className: "comp-info-text" }, { children: translate("app.programApplications.small.text.field.component.type.info") })))] })))] })) : (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type) === "LARGE_TEXT_AREA" ? (_jsxs(_Fragment, { children: [_jsx(ComponentLabelField, { fieldId: templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type.toLowerCase(), titleError: largeInputAreaLabelError, fieldValue: largeTextAreaInputLabel, titleHandler: updateLargeTextAreaInputHandler, errorMessage: inputFieldErrorMessage, isMandatory: isMandatory, setIsMandatory: setIsMandatory }), _jsxs("div", Object.assign({ className: "word-limit-field" }, { children: [_jsx(Inputfield, { fieldType: "number", minValue: 0, maxValue: maxWordCountLargeTextArea, titleError: wordLimitError, dataLabel: "Word Limit ", modalTitle: wordLimitInputLable.toString(), updateTitleHandler: updateWordLimitInputHandler, inputRef: titleRef, modalFor: "word-limit", modalId: (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type)
                                            ? (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type.toLowerCase()) + "-limit"
                                            : "", required: true, customError: true, customErrorMessage: wordLimitErrorMessage }), _jsx("div", Object.assign({ className: "comp-info-text" }, { children: translate("app.programApplications.component.largeTextArea.wordLimit.info.text") }))] }))] })) : (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type) === "TEXT" ? (_jsx(ComponentTextAreaField, { fieldLabel: getValueByKey(templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type, TemplateComponentList), fieldId: templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type.toLowerCase(), textareaError: textareaError, fieldValue: inputTextArea, maxLength: 1000, onChangeHandler: updateDesciptionHandler, errorMessage: textErrorMessage })) : (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type) === "FILE_UPLOAD" ? (_jsxs(_Fragment, { children: [_jsx(ComponentLabelField, { fieldId: templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type.toLowerCase(), titleError: inputFieldError, fieldValue: fileUploadInputLabel, titleHandler: updateFileUploadInputHandler, errorMessage: inputFieldErrorMessage, isMandatory: isMandatory, setIsMandatory: setIsMandatory }), _jsx("div", Object.assign({ className: "max-files-field" }, { children: _jsx(Inputfield, { fieldType: "number", minValue: 0, maxValue: maxFilesCountFileUpload, titleError: maxFilesError, dataLabel: maxFilesLabel, modalTitle: maxFiles.toString(), updateTitleHandler: updateMaxFilesCountHandler, inputRef: titleRef, modalFor: "max-files", modalId: (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type.toLowerCase()) + "-max-files", required: true, customError: true, customErrorMessage: maxFilesErrorMessage }) }))] })) : (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type) === "LINK_RESOURCE" ? (_jsxs("div", Object.assign({ className: "component-input" }, { children: [_jsxs("div", Object.assign({ className: "resource-link-field" }, { children: [_jsxs("label", Object.assign({ className: "textfieldlabel " +
                                            (inputFieldError || invalidLinkError ? "alert-label" : ""), htmlFor: (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type)
                                            ? "input-" + (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type.toLowerCase())
                                            : "" }, { children: ["URL ", _jsx("span", Object.assign({ className: "reqd" }, { children: "*" })), (inputFieldError || invalidLinkError) && (_jsx("span", { className: "alert-icon mdi mdi-alert" }))] })), _jsxs("div", Object.assign({ className: "textfield " +
                                            (inputFieldError || invalidLinkError ? "alert-box" : "") }, { children: [_jsx("div", Object.assign({ className: "charcount" }, { children: _jsx("input", { className: "textfieldinput " +
                                                        (inputFieldError || invalidLinkError ? "invalid" : ""), id: (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type)
                                                        ? "input-" + (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type.toLowerCase())
                                                        : "", type: "text", required: true, "aria-required": true, value: linkResourceInputLabel, onChange: updateResourceLinkHandler, onBlur: validateURLHandler, ref: titleRef, "aria-labelledby": "title-error-" + (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type.toLowerCase()) }) })), _jsx("div", Object.assign({ className: "error-info" }, { children: _jsx("div", Object.assign({ className: "error input-error", id: "title-error-" + (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type.toLowerCase()) }, { children: invalidLinkError
                                                        ? urlInvalidErrorMessage
                                                        : inputFieldError
                                                            ? urlRequiredErrorMessage
                                                            : "" })) }))] }))] })), _jsx(Inputfield, { titleError: false, dataLabel: "Display Text", modalTitle: linkDisplayTextLabel, updateTitleHandler: (event) => {
                                    event.preventDefault();
                                    setLinkDisplayTextLabel(event.target.value);
                                }, inputRef: titleRef, modalFor: "link-display-text", modalId: (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type)
                                    ? (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type.toLowerCase()) + "-display-text"
                                    : "", maxLength: 250 }), _jsx("div", Object.assign({ className: "comp-info-text" }, { children: translate("app.programApplications.component.link.resource.display.info.text") }))] }))) : (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type) === "ATTACHMENT" ? (_jsxs("div", Object.assign({ className: "component-input" }, { children: [_jsx(Inputfield, { titleError: false, dataLabel: "Label", modalTitle: attachmentDisplayTextLabel, updateTitleHandler: (event) => {
                                    event.preventDefault();
                                    setAttachmentDisplayTextLabel(event.target.value);
                                }, inputRef: titleRef, modalFor: "attachment-label", modalId: (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type)
                                    ? templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type.toLowerCase()
                                    : "", maxLength: 75 }), _jsx("div", Object.assign({ className: "comp-info-text" }, { children: translate("app.programApplications.component.attachment.display.info.text") })), _jsx(WmUploader, Object.assign({ id: "attach-file-component", className: "attach-files-uploader", label: attachFilesLabel, icon: "f3e2", buttonText: attachButtonText, requiredField: true, maxFiles: 5, maxSize: "50 MB", errorMessage: noAttachmentError
                                    ? noAttachmentErrorMsg
                                    : extraFileError
                                        ? extraFileErrorMessage
                                        : "", fileTypes: "docx doc pdf jpg png gif pptx ppt xlsx xls csv txt log xml", onWmUploaderFilesSelected: (event) => {
                                    setNoAttachmentError(false);
                                    onWmUploaderFilesSelected(event);
                                    if (event.target.maxFiles &&
                                        Array.from(event.target.querySelectorAll("wm-file")).filter((file) => !(file === null || file === void 0 ? void 0 : file.errorMessage)).length +
                                            event.detail.length >
                                            event.target.maxFiles) {
                                        setExtraFileError(true);
                                    }
                                    else {
                                        setExtraFileError(false);
                                    }
                                }, ref: uploaderRef, placeholder: undefined }, { children: uploaderComponentFiles === null || uploaderComponentFiles === void 0 ? void 0 : uploaderComponentFiles.map((file) => {
                                    return (_jsx(WmFile, { id: file.id, name: file.name, type: file.type, lastUpdated: !isNullOrEmpty(file === null || file === void 0 ? void 0 : file.lastUpdated)
                                            ? format(generateUTCDate(new Date(file.lastUpdated)), "MM/dd/yyyy h:mm a")
                                            : "", onWmFileDownload: (event) => onWmUploaderDownloadFile(event), onWmFileDelete: (event) => onWmUploaderDeleteFile(event), progress: file.progress, placeholder: undefined }, file.id));
                                }) }), JSON.stringify(uploaderComponentFiles))] }))) : (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type) === "DROPDOWN" ? (_jsxs(_Fragment, { children: [_jsx(ComponentLabelField, { fieldId: (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type)
                                    ? templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type.toLowerCase()
                                    : "", titleError: dropDownLabelError, fieldValue: dropDownDisplayTextLabel, titleHandler: updateDropDownInputHandler, errorMessage: inputFieldErrorMessage, isMandatory: isMandatory, setIsMandatory: setIsMandatory }), _jsx(TemplateComponentOptions, { optionList: optionList, setOptionList: setOptionList, componentType: templateComponent.type })] })) : (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type) === "MULTISELECT_CHECKBOXES" ? (_jsxs(_Fragment, { children: [_jsx(ComponentLabelField, { fieldId: (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type)
                                    ? templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type.toLowerCase()
                                    : "", titleError: multiSelectLabelError, fieldValue: multiSelectDisplayTextLabel, titleHandler: updateMultiSelectInputHandler, errorMessage: inputFieldErrorMessage, isMandatory: isMandatory, setIsMandatory: setIsMandatory }), _jsx(TemplateComponentOptions, { optionList: optionList, setOptionList: setOptionList, componentType: templateComponent.type })] })) : (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type) === "ACKNOWLEDGEMENT_CHECKBOX" ? (_jsxs(_Fragment, { children: [_jsx(ComponentLabelField, { fieldId: templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type.toLowerCase(), titleError: false, isRequired: false, fieldValue: ackCheckboxDisplayTextLabel, titleHandler: (event) => {
                                    event.preventDefault();
                                    setAckCheckboxDisplayTextLabel(event.target.value);
                                }, isMandatory: isMandatory, setIsMandatory: setIsMandatory }), _jsx(ComponentTextAreaField, { fieldLabel: ackTextLabel, fieldId: "textarea-" + (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type.toLowerCase()), textareaError: ackTextError, fieldValue: ackCheckboxInputText, maxLength: 2000, onChangeHandler: updateAckCheckboxTextHandler, errorMessage: ackInputTextError, fieldHelpText: ackCheckboxHelpText })] })) : (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type) === "RADIO_BUTTON" ? (_jsxs(_Fragment, { children: [_jsx(ComponentLabelField, { fieldId: (templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type)
                                    ? templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.type.toLowerCase()
                                    : "", titleError: radiobuttonLabelError, fieldValue: radioButtonDisplayTextLabel, titleHandler: updateRadioButtonSelectInputHandler, errorMessage: inputFieldErrorMessage, isMandatory: isMandatory, setIsMandatory: setIsMandatory }), _jsx(TemplateComponentOptions, { optionList: optionList, setOptionList: setOptionList, componentType: templateComponent.type })] })) : null] })));
        }
    };
    const renderFlyoutFooter = () => {
        if (!isEditComponentClicked && flyoutView === "componentSettings") {
            return (_jsx("footer", Object.assign({ className: "flyout-footer" }, { children: _jsxs("div", Object.assign({ className: "button-collection" }, { children: [_jsx(WmButton, Object.assign({ buttonType: "secondary", id: "back-button", onClick: () => goBackHandler(), disabled: uploadInProgress, placeholder: undefined }, { children: translate("app.programApplications.component.footer.back.label") })), _jsx(WmButton, Object.assign({ buttonType: "primary", id: "insert-btn", onClick: saveApplicationComponentHandler, disabled: uploadInProgress, placeholder: undefined }, { children: translate("app.programApplications.component.footer.insert.label") }))] })) })));
        }
        else if (isEditComponentClicked) {
            return (_jsx("footer", Object.assign({ className: "flyout-footer" }, { children: _jsx(WmButton, Object.assign({ buttonType: "primary", id: "save-btn", onClick: saveApplicationComponentHandler, disabled: uploadInProgress, placeholder: undefined }, { children: translate("global.saveButtonText") })) })));
        }
        else {
            return;
        }
    };
    return (_jsxs("div", Object.assign({ className: "flyout-panel half-flyout show", role: "dialog", id: "insert-component-flyout", tabIndex: -1, "aria-label": "Insert Component" }, { children: [_jsx("div", { className: "overlay" }), _jsxs("div", Object.assign({ className: "container" }, { children: [renderFlyoutHeader(), renderMainContent(), renderFlyoutFooter()] }))] })));
}
